import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RequestExternalAuditModel } from 'app/company-audit/models/request-external-audit.model';
import { SharedService } from 'app/shared/services/shared.service';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { User } from 'app/shared/models/User';
import { AuditCategoryModel } from 'app/audit-template/models/audit-category.model';
import { AuditTemplateDetailsModel } from '../../../audit-template/models/audit-template-details.model';

@Component({
  selector: 'app-request-external-audit',
  templateUrl: './request-external-audit.component.html',
  styleUrls: ['./request-external-audit.component.css']
})
export class RequestExternalAuditComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    requestAudit: RequestExternalAuditModel;
    auditTemplates: AuditTemplateDetailsModel[];
    submitAttempt: boolean = false;
    submitSuccesful: boolean = false;
    companyId: string;
    auditTypeId: number;
    requestExteralAuditForm: FormGroup;
    user: User;
    isAdmin: boolean = false;
    companyUserList: CompanyUserModel[];
    auditCategoryList: AuditCategoryModel[];
    categoryString: string;
    showForm: boolean = false;
    selectedCompany: CompanyUserModel;
    showNoAuditAlert = false;
    cId: string = "none";

    constructor(
        private companyAuditService: CompanyAuditService,
        private sharedService: SharedService,
        private auditTemplateService: AuditTemplateService,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {

        this.sharedService.currentUser.subscribe(user => {
            this.user = user;
            this.isAdmin = this.user.isAdmin;
            this.sharedService.currentCompanyUser.subscribe(companyUser => {
                this.companyUserList = companyUser;
                if (this.companyUserList.length == 1) {
                    this.companyId = this.companyUserList[0].companyId;
                    this.selectedCompany = this.companyUserList[0];
                    this.showForm = true;
                    this.initialiseForm();
                }
                if (this.isAdmin) {
                    this.headerTitle = {
                        title: 'Request External Audit',
                        breadcrumbs: [
                            { title: 'Company Audits', url: ['/company-audit'] }
                        ]
                    };
                } else {
                    this.headerTitle = {
                        title: 'Request External Audit'
                    };
                }
            });
        });

    }

    initialiseForm(): void {

        this.getAuditTemplates(this.selectedCompany.companyId);

        this.requestExteralAuditForm = this.fb.group(
            {
                siteUserId: [this.selectedCompany.siteUserId],
                siteUserName: [this.selectedCompany.firstName + ' ' + this.selectedCompany.lastName],
                siteUserEmail: [this.selectedCompany.email],
                siteUserPhone: [this.selectedCompany.companyPhoneNr],
                companyId: [this.companyId],
                companyName: [this.selectedCompany.tradingName == "" ? this.selectedCompany.legalName : this.selectedCompany.tradingName],
                auditTypeId: '',
                auditTypeName: '',
                message: ['']
            }
        );
    }

    submitRequest = () => {
        let auditRequest: RequestExternalAuditModel = {
            auditTypeId: this.requestExteralAuditForm.controls.auditTypeId.value,
            auditTypeName: this.requestExteralAuditForm.controls.auditTypeName.value,
            siteUserId: this.requestExteralAuditForm.controls.siteUserId.value,
            siteUserName: this.requestExteralAuditForm.controls.siteUserName.value,
            siteUserEmail: this.requestExteralAuditForm.controls.siteUserEmail.value,
            siteUserPhone: this.requestExteralAuditForm.controls.siteUserPhone.value,
            companyId: this.requestExteralAuditForm.controls.companyId.value,
            companyName: this.requestExteralAuditForm.controls.companyName.value,
            message: this.requestExteralAuditForm.controls.message.value
        }



        this.companyAuditService.requestExternalAudit(auditRequest).subscribe(result => {
            this.submitSuccesful = true;
        },
            error => {
                this.errors = error.errorList;
            }
        );
    }

    getAuditTemplates(companyId): void {
        this.auditTemplateService.getAllForCompany(companyId).subscribe(result => {
            this.auditTemplates = result;
            if (this.auditTemplates.length == 0) {
                this.showNoAuditAlert = true;
            } else if (this.auditTemplates.length == 1) {
                this.selectAuditType(this.auditTemplates[0].auditCategoryId);
            }
        });
    }

    setCompany(cId): void {
        this.companyId = cId;
        this.selectedCompany = this.companyUserList.find(x => x.companyId === cId);
        this.showForm = true;
        this.initialiseForm();
    }

    unSetCompany(): void {
        this.companyId = "none";
        this.showForm = false;
        this.showNoAuditAlert = false;
    }
    selectAuditType(auditTypeId): void {
        var y = this.auditTemplates.find(x => x.id == auditTypeId);
        this.requestExteralAuditForm.patchValue({
            auditTypeId: y.auditCategoryId,
            auditTypeName: y.auditCategoryDescription
        });
    }

}
